import React from 'react';
import styles from "./JobShiftPreStartView.module.css";

export default function JobShiftPreStartViewHeader({ sections, preStartData }) {

  const projectSection = sections.document_project_details || {};
  const projectDetails = projectSection.data || {};
  const orgDetails = projectDetails.org_details || {};
  const orgName = orgDetails.name || "";
  const orgLetter = orgName ? orgName.charAt(0) : "";
  const swmsNumber = projectDetails.swms_number || "";
  const preStartNumber = preStartData && preStartData.pre_start_id ? preStartData.pre_start_id : "";
  const swmsVersion = projectDetails.swms_version;
  const revNumber = (swmsVersion && swmsVersion.slice(1)) || "1";
  const shiftId = preStartData && preStartData.shift_id ? preStartData.shift_id : "";

  return (
    <div className={styles.PreviewDocBand} id="prv-doc-band">
      <div className={styles.PreviewDocBandLetter}>
        <div className={styles.PreviewDocBandMark}>{orgLetter}</div>
        <div>
          <div className={styles.PreviewDocBandName}>{orgName}</div>
          <div className={styles.PreviewDocBandSub}>SWMS Pre-Start Checklist</div>
        </div>
      </div>
      <div className={styles.PreviewDocBandRight}>
        <div className={styles.PreviewDocBandNo}>{preStartNumber}</div>
        <div>Rev {revNumber} &middot; Shift {shiftId} &middot; {swmsNumber}</div>
        <div>Controlled — Uncontrolled if Printed</div>
      </div>
    </div>
  )
}